/* eslint-disable */
export default {
  title: 'Rispondi con messaggio vocale',
  customMessage: 'Messaggio personalizzato',
  customMessagePlaceholder: 'Digita un messaggio personalizzato',
} as const;

// @key: @#@"title"@#@ @source: @#@"Reply with Voice Message"@#@
// @key: @#@"customMessage"@#@ @source: @#@"Custom message"@#@
// @key: @#@"customMessagePlaceholder"@#@ @source: @#@"Type a custom message"@#@
